<template>
  <div class="homeBox">
    <el-container direction="vertical">
      <el-header height="80px">
        <div class="name-container" @click="jumpHome">
            <img src="../assets/logo.png"/>
            <span>{{$t('companyName')}}</span>
        </div>

        <div class="menu-container hidden-xs-only">
          <el-menu
            :default-active="currentActive"
            class="menu-container"
            router
            mode="horizontal"
            text-color="#ffffff"
            active-text-color="#448DFF"
            background-color="#061E34"
            menu-trigger='hover'
          >
            <el-menu-item index='/'>{{$t('home')}}</el-menu-item>
            <el-menu-item index='/solution'>{{$t('solution')}}</el-menu-item>
            <el-submenu index="productService" :hide-timeout=400>
              <template slot="title">{{$t('productService')}}</template>
              <el-menu-item index='/modao'>{{$t('modao')}}</el-menu-item>
              <el-menu-item index='/mohe'>{{$t('mohe')}}</el-menu-item>
            </el-submenu>
            <el-menu-item index='/business'>{{$t('businessCop')}}</el-menu-item>
            <el-submenu index="aboutus" :hide-timeout=400 >
              <template slot="title">{{$t('aboutus')}}</template>
              <el-menu-item index='/introduce'>{{$t('introduceCom')}}</el-menu-item>
              <el-menu-item index='/joinus'>{{$t('joinUs')}}</el-menu-item>
            </el-submenu>
            <el-menu-item @click="selectLanguage">{{ isEn ? '中文' : 'EN'}}</el-menu-item>
          </el-menu>
        </div>

        <!-- <el-dropdown :hide-on-click="false" class="hidden-sm-and-up"> -->
        <!-- <el-dropdown trigger="click">
          <img src="../assets/menu_icon.png" class="el-dropdown-link"/>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>黄金糕</el-dropdown-item>
            <el-dropdown-item>狮子头</el-dropdown-item>
            <el-dropdown-item>螺蛳粉</el-dropdown-item>
            <el-dropdown-item >双皮奶</el-dropdown-item>
            <el-dropdown-item >蚵仔煎</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->


        <img src="../assets/menu_icon.png" class="drop-down-img hidden-sm-and-up" @click="showTreeMenuAction"/>



      </el-header>

      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>



    <!-- <el-tree :data="menuData" 
              class="tree-menu" 
              v-if="showTreeMenu"
              @node-click="handleNodeClick">
    </el-tree> -->

    <transition name="moveT">
      <div class="tree-container hidden-sm-and-up" v-if="showTreeMenu">
        <el-tree :data="menuData" 
                  class="tree-menu" 
                  v-if="showTreeMenu"
                  @node-click="handleNodeClick">
        </el-tree>
      </div>
    </transition>

  </div>
</template>

<script>
export default {

  data(){
    return {
      isEn: false,
      currentActive: "",
      showTreeMenu: false,

      menuData: [
        {
          label: this.$t('home'),
        },
        {
          label: this.$t('solution'),
        },
        {
          label: this.$t('productService'),
          children: [
            {
              label: this.$t('modao')
            },
            {
              label: this.$t('mohe')
            }
          ]
        },
        {
          label: this.$t('businessCop'),
        },
        {
          label: this.$t('aboutus'),
          children: [
            {
              label: this.$t('introduceCom')
            },
            {
              label: this.$t('joinUs')
            }
          ]
        },
        {
          label: 'EN',
        },
      ]
    }
  },

  created(){
    this.currentActive = this.$route.path;

    const locale = localStorage.getItem('locale');
    if(!locale || locale === 'en'){
      this.isEn = true;
    }else{
      this.isEn = false;
    }
  },

  watch: {

    $route(to, from){
      this.currentActive = to.path;
    },

    isEn(val){
      if(val){
        this.menuData = [
        {
          label: this.$t('home'),
        },
        {
          label: this.$t('solution'),
        },
        {
          label: this.$t('productService'),
          children: [
            {
              label: this.$t('modao')
            },
            {
              label: this.$t('mohe')
            }
          ]
        },
        {
          label: this.$t('businessCop'),
        },
        {
          label: this.$t('aboutus'),
          children: [
            {
              label: this.$t('introduceCom')
            },
            {
              label: this.$t('joinUs')
            }
          ]
        },
        {
          label: '中文',
        },
      ]
      }else{
        this.menuData = [
        {
          label: this.$t('home'),
        },
        {
          label: this.$t('solution'),
        },
        {
          label: this.$t('productService'),
          children: [
            {
              label: this.$t('modao')
            },
            {
              label: this.$t('mohe')
            }
          ]
        },
        {
          label: this.$t('businessCop'),
        },
        {
          label: this.$t('aboutus'),
          children: [
            {
              label: this.$t('introduceCom')
            },
            {
              label: this.$t('joinUs')
            }
          ]
        },
        {
          label: 'EN',
        },
      ]
     }
    }
  },
  
  methods: {

    selectLanguage(){
        if(this.isEn){
          localStorage.setItem('locale', 'zh');
          this.$i18n.locale = 'zh';
          this.isEn = false;
        } else {
          localStorage.setItem('locale', 'en');
          this.$i18n.locale = 'en';
          this.isEn = true;
        }
    },

    jumpHome(){
      this.$router.push('/');
    },

    showTreeMenuAction(){
      if(this.showTreeMenu){
        this.showTreeMenu = false;
      }else{
        this.showTreeMenu = true;
      }
    },

    handleNodeClick(data){
      console.log(data);
      if(data.children && data.children.length) return;
      this.showTreeMenu = false;
      const title = data.label;
      switch(title){
        case this.$t('home'):
          this.$router.push('/');
          break;
        case this.$t('solution'):
          this.$router.push('/solution');
          break;
        case this.$t('modao'):
          this.$router.push('/modao');
          break;
        case this.$t('mohe'):
          this.$router.push('/mohe');
          break;
        case this.$t('businessCop'):
          this.$router.push('/business');
          break;
        case this.$t('introduceCom'):
          this.$router.push('/introduce');
          break;
        case this.$t('joinUs'):
          this.$router.push('/joinus');
          break;
        case 'EN':
        case '中文':
          this.selectLanguage();
          break;
      }
    },
  }
  
}
</script>

<style lang="less" scoped>

html, body, #app, .homeBox, .el-container{
  padding: 0;
  margin: 0;
  height: 100% ;
  
  .el-menu-item{
    font-size: 35px !important; /*px*/
    height: 100%;
    line-height: 90px;
    &:hover{
      color: #448DFF !important;
    }
  }
}

.el-menu{
  // font-size: 35px; 
  height: 100%;
  line-height: 90px; 
}

.el-header {
  background-color: #061E34;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 100px;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
  line-height: 100%;
  height: calc(100vh - 80px);
  padding: 0;
}

.name-container{
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  font-size: 60px;/*px*/
  font-family:PingFangSC-Semibold,PingFang SC;
  font-weight:600;
  cursor: pointer;
  img{

    margin-right: 20px;
    width: 120px;/*px*/
    height: 120px;/*px*/
  }
}

.menu-container{
  border-bottom: none;
  height: 100%;
  // vertical-align: middle;
  // text-align: center;

  // /deep/.el-menu-item{
  //   vertical-align: middle;
  //   line-height: 80px;
  //   height: 100%;

  //   font-size: 35px !important;
  // }


  // /deep/.el-submenu{
  //   height: 100%; 
  //   line-height: 80px;
  // }

  // /deep/.el-submenu__title{
  //   font-size: 35px; /*px*/
  //   height: 100%;
  //   line-height: 80px; 
  // }
  /deep/ .el-menu--horizontal>.el-submenu .el-submenu__title{
    font-size: 35px; /*px*/
    height: 100%;
    line-height: 90px; 
    vertical-align: middle;
    &:hover{
      color: #448DFF !important;
    }

  }

  /deep/ .el-menu--horizontal>.el-menu-item.is-active{
    border-bottom-width: 3px; /*no*/
  }
  /deep/.el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
    border-bottom-width: 3px; /*no*/
  }

  /deep/ .el-menu.el-menu--horizontal{
    border: none;
  }
}

  .el-submenu{
    height: 100%; 
    // line-height: 80px;
  }


  //  .is-active{
  //   border-bottom-width: 3px; 
  //   height: 100%;
  // }
  // .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
  //   border-bottom-width: 3px; 
  // }


.el-menu--horizontal .el-menu .el-menu-item {
  font-size: 30px !important;  /*px*/
  height: 80px; /*px*/
  line-height: 80px; /*px*/
  letter-spacing: 3px;
}





.drop-down-img{
  width: 40px; /*no*/
  height: 40px;/*no*/
  cursor: pointer;
}
.tree-menu{
  z-index: 2400;
  // position: absolute;
  // top: 80px; /*no*/
  background-color: #061E34;
  border: none;
  width: calc(100vw);
  padding: 0 20px; /*no*/

  /deep/ .el-tree-node{
    background-color: #061E34;
    &:hover{
      background-color: transparent;
      // color: #448DFF;
    }
  }
  /deep/ .el-tree-node .el-tree-node__children .is-focusable{
    
    &:hover{
      background-color: transparent;
      // color: #448DFF;
    }

  }
  /deep/ .el-tree-node .el-tree-node__content{
    height: 40px; /*no*/
    // background-color: none !important;
    color: #fff; 
    .el-tree-node__label{
    font-size: 20px;  /*no*/

    }
    &:hover{
      background-color: transparent;
      color: #448DFF;
    }

  }

  /deep/ .el-tree-node .el-tree-node__children .el-tree-node__content{
    height: 30px; /*no*/
    // background-color: none !important;
    color: rgb(230, 230, 230); 

    .el-tree-node__label{
      font-size: 15px;  /*no*/
    }
    &:hover{
      background-color: transparent;
      color: #448DFF;
    }
  }

  /deep/ .el-tree-node:focus>.el-tree-node__content{
    background-color: transparent;
  }
}

.moveT-enter-active {
  transition: all 0.3s ease-out;
}
.moveT-enter, .moveT-leave-to{
  height: 0px !important;
}
.moveT-enter-to{
  height: 200px; 
}

.tree-container{
  height: 400px; /*no*/
  width: calc(100vw);
  background-color: transparent;
  z-index: 2400;
  position: absolute;
  top: 80px; /*no*/
  overflow: hidden;
}




.el-dropdown{
  img{
    width: 40px; /*no*/
    height: 40px;/*no*/
  }
}

.el-dropdown-menu{
  background-color: #061E34;
  border: none;
  width: calc(100vw);
}

.el-dropdown-menu__item{
  height: 40px; /*no*/
  font-size: 20px; /*no*/
  line-height: 40px;/*no*/
  color: white;
  &:hover{
    background-color: transparent;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Container.vue